import { create } from "zustand";

export type UserRole = string;
export type AuthStatus = "initializing" | "authenticated" | "anonymous";

export interface CurrentUser {
  id: string;
  fullName: string;
  role: UserRole;
  roles: string[];
  permissions: string[];
  username: string;
}

interface UserState {
  currentUser: CurrentUser | null;
  accessToken: string | null;
  authStatus: AuthStatus;
}

interface UserActions {
  setAuthenticated: (user: CurrentUser, accessToken: string) => void;
  clearSession: () => void;
}

const initialState: UserState = {
  currentUser: null,
  accessToken: null,
  authStatus: "initializing",
};

export const useUserStore = create<UserState & UserActions>()((set) => ({
  ...initialState,

  setAuthenticated: (currentUser, accessToken) =>
    set({ currentUser, accessToken, authStatus: "authenticated" }),
  clearSession: () =>
    set({ currentUser: null, accessToken: null, authStatus: "anonymous" }),
}));
